// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// Скрипт предоставлен подрядчиком.
// Для внедрения скрипта, в том виде, в котором он был предоставлен, отключены проверки ts.
import { TRUE_PRODUCTION_DOMAIN } from "../../constants";

export const getCMODigitalPersonalizationConfig = () => {
  switch (process.env.APP_ENV) {
    case "production": {
      /**
       * Из-за невозможности перенести логику определения true-prod стенда на сторону коллектора,
       * определяем его по названию домена на котором запущено приложение.
       * Необходимо убрать этот код если будет найдено более гибкое решение.
       * */
      const isTrueProd = window.location.hostname.includes(
        TRUE_PRODUCTION_DOMAIN
      );

      if (isTrueProd) {
        return {
          reverseProxyURL: "https://rp.rshb.ru:8443/api/personalizations",
        };
      }

      return {
        reverseProxyURL: "https://dev-rp.rshb.ru:8443/api/personalizations",
      };
    }

    case "rc": {
      return {
        reverseProxyURL: "https://dev-rp.rshb.ru:8443/api/personalizations",
      };
    }

    case "development":

    default: {
      return {
        reverseProxyURL: "https://dev-rp.rshb.ru:443/api/personalizations",
      };
    }
  }
};

export const runCMODigitalPersonalization = () => {
  const { reverseProxyURL } = getCMODigitalPersonalizationConfig();

  if (!reverseProxyURL) {
    return;
  }

  const PersPlugin = {
    PersPlugin: function () {
      return {
        beforeTrack: (payload) => {
          const data = window.cmo.getDataFromPayloadBuilder(payload);

          if (
            "event_data" in data &&
            "eventAction" in data.event_data &&
            data.event_data.eventAction === "activityPageVisit"
          ) {
            const client = new window.cmo.CMOPersonalisationClient(
              reverseProxyURL,
              "POP-UP",
              {
                duid: data.duid,
                cftId: data.event_data.cftId,
                branchId: data.event_data.branchId,
              },
              {
                context: data,
              }
            );

            const contactPoint = new window.cmo.PopupContactPoint(
              "next.rshb.ru",
              {
                responseEventSchema: "iglu:rp/popup-response/jsonschema/1-0-0",
                responseEventContext: () => ({
                  platform: "dbo",
                  eventCategory: "popupResponse",
                  cftId: data.event_data.cftId,
                  branchId: data.event_data.branchId,
                }),
              }
            );

            client.registerContactPoint(contactPoint);
            client.fetchAndApplyContent();
          }

          payload.build();
        },
      };
    },
  };

  window.snowplow?.("addPlugin:events", PersPlugin, "PersPlugin");
};
